import { useTranslation } from 'react-i18next';
import { useGetCurrentTenantQuery } from '@/store/tenantApi';
import { BannerBar } from './DemoBanner.styled';

export default function DemoBanner() {
  const { t } = useTranslation();
  const { data: tenant } = useGetCurrentTenantQuery();

  if (!tenant || tenant.type !== 'Demo') return null;

  return <BannerBar>{t('demoBanner.message')}</BannerBar>;
}
